import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFlowerCustomerList as _getFlowerCustomerList, getFlowerMoneyTypes as _getFlowerMoneyTypes, getEditFlowerRule, handChannelWarningRestrictions, getEditFlowerRuleCustom as _getEditFlowerRuleCustom } from '@/api/goodsCenter';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      customRadio: 1,
      goodsRadio: -1,
      activeName: 'custom',
      customForm: {
        id: '',
        name: '',
        page: 1,
        page_size: 20
      },
      cinemaForm: {
        cinema_name: '',
        standard_id: '',
        page: 1,
        pagesize: 20
      },
      // 列表查询参数
      setFormRule: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        rule_name: '',
        money_type: '',
        adjust_type: ['1'],
        selected_goods_ids: -1
      }, "money_type", '1'), "by_ratio_adjust", ''), "by_money_adjust", ''), "is_show_line_price", '0'), "line_price_field", '1'),
      selected_standard_ids: [],
      tableKey: 0,
      pages: {},
      totalCount: null,
      customList: [],
      checkedCustom: [],
      checkedDelCustom: [],
      checkedCustomList: [],
      rule_id: '',
      // 有值为编辑 没值则为添加
      ruleType: '',
      moneyTypes: [],
      line_price_field_type: [],
      warning_restrictions: 0,
      // 折扣预警值
      warningLoaded: false // 预警值是否已加载
    };
  },
  computed: {
    priceType: function priceType() {
      if (this.setFormRule.adjust_type.length == 2) {
        return 'all';
      } else if (this.setFormRule.adjust_type.length) {
        if (this.setFormRule.adjust_type[0] == 1) {
          return 'ratio';
        } else {
          return 'money';
        }
      } else {
        return '';
      }
    }
  },
  created: function created() {
    var _ids;
    var ids = this.$route.query.ids;
    if (typeof ids === 'string') {
      ids = [ids];
    }
    this.selected_standard_ids = (_ids = ids) !== null && _ids !== void 0 && _ids.length ? ids : '';
    this.getChannelWarningRestrictions();
  },
  methods: {
    // 获取折扣预警
    getChannelWarningRestrictions: function getChannelWarningRestrictions() {
      var _this = this;
      handChannelWarningRestrictions().then(function (res) {
        _this.warning_restrictions = Number(res.data.warning_restrictions);
      });
    },
    // 添加调价规则
    getList: function getList() {
      var _this2 = this;
      // 客户列表
      this.getFlowerCustomerList();
      // 调价基数
      this.getFlowerMoneyTypes();
      this.$nextTick(function () {
        _this2.dialogVisible = true;
      });
    },
    // 编辑调价规则
    getEditInfo: function getEditInfo() {
      var _this3 = this;
      this.getFlowerMoneyTypes();
      this.getFlowerCustomerList();
      this.getEditFlowerRuleCustom();
      // 编辑获取设置影院规则数据
      getEditFlowerRule({
        rule_id: this.rule_id
      }).then(function (res) {
        _this3.setFormRule = res.data.data;
        _this3.dialogVisible = true;
      });
    },
    // 编辑获取已选客户
    getEditFlowerRuleCustom: function getEditFlowerRuleCustom() {
      var _this4 = this;
      _getEditFlowerRuleCustom({
        rule_id: this.rule_id,
        pagesize: 10000
      }).then(function (res) {
        _this4.checkedCustomList = res.data.data.data;
      });
    },
    getFlowerMoneyTypes: function getFlowerMoneyTypes() {
      var _this5 = this;
      _getFlowerMoneyTypes().then(function (res) {
        _this5.moneyTypes = res.data.data;
        _this5.line_price_field_type = res.data.line_price_types;
      });
    },
    // 获取客户列表
    getFlowerCustomerList: function getFlowerCustomerList() {
      var _this6 = this;
      _getFlowerCustomerList(this.customForm).then(function (res) {
        _this6.customList = res.data.list;
        _this6.pages = res.pages;
      });
    },
    // 设置规则弹框 待选择客户table 选中事件
    handleSelectionCustom: function handleSelectionCustom(val, type) {
      if (type == 'custom') {
        this.checkedCustom = val;
      } else {
        this.checkedCinema = val;
      }
    },
    // 设置规则弹框 已选择客户table选中事件
    handleCheckedDelCustom: function handleCheckedDelCustom(val, type) {
      if (type == 'custom') {
        this.checkedDelCustom = val;
      }
    },
    // 搜索设置规则里的查询客户
    searchCustom: function searchCustom(type) {
      if (type == 'custom') {
        this.customForm.page = 1;
        this.getFlowerCustomerList();
      }
    },
    // 设置规则 批量添加客户
    batchAddCustom: function batchAddCustom(type) {
      if (type == 'custom') {
        var _this$checkedCustomLi;
        if (!this.checkedCustom.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        (_this$checkedCustomLi = this.checkedCustomList).push.apply(_this$checkedCustomLi, _toConsumableArray(this.checkedCustom));
        this.$refs.multipleTable.clearSelection();
      } else {
        this.tableKey++;
        if (!this.checkedCinema.length) {
          this.$message.info('请选择需添加的客户');
          return false;
        }
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 批量删除客户
    batchDel: function batchDel(type) {
      var _this7 = this;
      if (type == 'custom') {
        this.checkedDelCustom.forEach(function (item) {
          var index = _this7.checkedCustomList.indexOf(item);
          if (index !== -1) {
            _this7.checkedCustomList.splice(index, 1);
          }
        });
      }
    },
    // 待选择客户的禁用选项框条件
    selectableCustom: function selectableCustom(row) {
      var flag = true;
      this.checkedCustomList.forEach(function (e) {
        if (e.id == row.id) {
          flag = false;
        }
      });
      return flag;
    },
    submitAdjustRule: function submitAdjustRule() {
      var _this8 = this;
      this.$refs.setFormRule.validate(function (valid) {
        if (valid) {
          var params = _objectSpread(_objectSpread({}, _this8.setFormRule), {}, {
            selected_goods_ids: -1,
            selected_company_info: _this8.customRadio == 1 ? _this8.checkedCustomList.map(function (i) {
              return {
                company_name: i.company_name,
                id: i.id
              };
            }) : '-1',
            type: _this8.ruleType == 'add' ? 'add' : 'edit'
          });
          if (!_this8.checkedCustomList.length && _this8.customRadio == 1) {
            params.selected_company_info = '';
          }
          if (_this8.customRadio == -1 && _this8.goodsRadio == -1) {
            _this8.$message.info('已存在全局规则，无法选择全部商品和全部客户');
            return false;
          }
          _this8.$emit('emitSubmit', params);
        }
      });
    },
    // 分页操作
    onChange: function onChange(val, type) {
      if (type == 'custom') {
        this.customForm.page = val;
        this.getFlowerCustomerList();
      }
    },
    sizeChange: function sizeChange(val, type) {
      // this.form.pagesize = val
      if (type == 'custom') {
        this.customForm.page_size = val;
        this.getFlowerCustomerList();
      }
    },
    closeDialog: function closeDialog() {
      this.setFormRule = {
        rule_name: '',
        adjust_type: ['1'],
        by_ratio_adjust: '',
        by_money_adjust: '',
        money_type: '1',
        is_show_line_price: '0',
        line_price_field: '1'
      };
      this.customRadio = 1;
      this.goodsRadio = -1;
      this.activeName = 'custom';
      this.customForm = {
        name: '',
        id: ''
      };
      this.ruleType = '';
      this.$refs.setFormRule.resetFields();
      this.checkedCustomList = [];
    }
  }
};